export class AppConfig {
    
    //IMAGES
    public static DEFAULT_LOGO : string = "assets/img/logo.png";
    public static LOGO : string = "assets/FAC.png";
}
